/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_TeamsInputs */

const th_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดทีม…`)
};

const en_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading teams…`)
};

const ja_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームを読み込み中…`)
};

const zh_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载球队…`)
};

const es_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando equipos…`)
};

const pt_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando times…`)
};

const id_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat tim…`)
};

const fr_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des équipes…`)
};

const tl_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilo-load ang mga team…`)
};

const vi_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải đội…`)
};

const ko_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀을 불러오는 중…`)
};

const de_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams werden geladen…`)
};

const ru_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загружаем команды…`)
};

const tr_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takımlar yükleniyor…`)
};

const it_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento squadre…`)
};

const pl_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytywanie drużyn…`)
};

const uk_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажуємо команди…`)
};

const hi_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीमें लोड हो रही हैं…`)
};

const ar_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تحميل الفرق…`)
};

const ms_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat pasukan…`)
};

const bn_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল লোড হচ্ছে…`)
};

const zh_tw2_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入球隊…`)
};

const zh_hk2_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入球隊…`)
};

const ur_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیمیں لوڈ ہو رہی ہیں…`)
};

const fa_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال بارگذاری تیم‌ها…`)
};

const sw_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapakia timu…`)
};

const nl_loading_teams = /** @type {(inputs: Loading_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams laden…`)
};

/**
* | output |
* | --- |
* | "Loading teams…" |
*
* @param {Loading_TeamsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const loading_teams = /** @type {((inputs?: Loading_TeamsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_TeamsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_loading_teams(inputs)
	if (locale === "ja") return ja_loading_teams(inputs)
	if (locale === "zh") return zh_loading_teams(inputs)
	if (locale === "es") return es_loading_teams(inputs)
	if (locale === "pt") return pt_loading_teams(inputs)
	if (locale === "id") return id_loading_teams(inputs)
	if (locale === "fr") return fr_loading_teams(inputs)
	if (locale === "tl") return tl_loading_teams(inputs)
	if (locale === "vi") return vi_loading_teams(inputs)
	if (locale === "ko") return ko_loading_teams(inputs)
	if (locale === "de") return de_loading_teams(inputs)
	if (locale === "ru") return ru_loading_teams(inputs)
	if (locale === "tr") return tr_loading_teams(inputs)
	if (locale === "it") return it_loading_teams(inputs)
	if (locale === "pl") return pl_loading_teams(inputs)
	if (locale === "uk") return uk_loading_teams(inputs)
	if (locale === "hi") return hi_loading_teams(inputs)
	if (locale === "ar") return ar_loading_teams(inputs)
	if (locale === "ms") return ms_loading_teams(inputs)
	if (locale === "bn") return bn_loading_teams(inputs)
	if (locale === "zh-TW") return zh_tw2_loading_teams(inputs)
	if (locale === "zh-HK") return zh_hk2_loading_teams(inputs)
	if (locale === "ur") return ur_loading_teams(inputs)
	if (locale === "fa") return fa_loading_teams(inputs)
	if (locale === "sw") return sw_loading_teams(inputs)
	if (locale === "nl") return nl_loading_teams(inputs)
	return en_loading_teams(inputs)
});